<template>
  <aside class="articaside">
    <div v-if="ismu">
      <div class="directory" v-show="nodedata && ismuhide">
        <div
          class="directoryitem flex_start"
          v-for="(item, index) in nodedata"
          :key="index"
          @click="scrollto(index)"
        >
          <div class="asidedirsort">{{ index }}</div>
          <div class="asidedirtxt">
            <div>{{ item.ywname }}</div>
            <div>{{ item.name | toEllipsisFilter(17) }}</div>
          </div>
        </div>
      </div>
      <div
        class="notextselect asdeitem mu"
        @click="mushow"
        :class="{ muact: ismuhide }"
      >
        目录
      </div>
    </div>
	<div class="asdeitem dianz">
	  <svg-icon icon-class="dianzan" class="ic" />
	</div>
    <div class="asdeitem shouc">
      <svg-icon icon-class="shoucang" class="ic" />
    </div>
    
    <div class="asdeitem backup flip_90" @click="baupto">
      <svg-icon icon-class="jt_right" class="ic" />
    </div>
  </aside>
</template>

<script>
export default {
  props: {
    ismu:{
      type:Boolean,
      default:false,
    },
    nodedata: {
      type: Array,
      default() {
        return [];
      },
    },
    refname: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    ismuhide: true,
  }),
  mounted() {
    this.ismuhide = this.nodedata.length != 0;
  },
  methods: {
    scrollto(index) {
      let parentnode = this.$parent;
      parentnode.$refs[this.refname].children[index].scrollIntoView({
        behavior: "smooth",
      });
    },
    baupto() {
      document.querySelector(".header").scrollIntoView({
        behavior: "smooth",
      });
    },
    mushow() {
      this.ismuhide = !this.ismuhide;
    },
  },
};
</script>

<style lang="scss" scope>
.articaside {
  width: 70px;
  position: fixed;
  z-index: 9999;
  right: calc(50% - 300px - 60px);
  bottom: 10px;
  font-size: 30px;
  color: #0867ea;
  .asdeitem {
    margin-top: 12px;
    width: 54px;
    height: 54px;
    text-align: center;
    line-height: 54px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    font-size: 16px;
    color: #454545;
    border-radius: 5px;
  }
  .mu {
    &.muact {
      color: #fff;
      background: #0465ea;
    }
  }
  .shouc,
  .dianz,
  .backup {
    font-size: 30px;
    .ic {
      vertical-align: -0.05em;
    }
  }

  .directory {
    font-size: 16px;
    color: #333333;
    width: 300px;
    height: auto;
    // overflow-y: scroll;
    padding: 20px;
    background: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
    .directoryitem {
      margin-top: 20px;
      .asidedirsort {
        font-size: 20px;
        color: #333333;
        margin-right: 60px;
        position: relative;
        &::after {
          content: "";
          position: absolute;
          top: 20px;
          left: 40px;
          width: 2px;
          height: 60px;
          background: #eeeeee;
        }
        &::before {
          content: "";
          position: absolute;
          top: 10px;
          left: 40px;
          z-index: 2;
          width: 12px;
          height: 12px;
          transform: translateX(-5px);
          background: #0465ea;
          border-radius: 50%;
        }
      }
      .asidedirtxt {
        cursor: pointer;
        font-size: 16px;
        color: #333333;
      }

      &:first-child {
        margin-top: 0;
      }
      &:last-child {
        .asidedirsort::after {
          display: none;
        }
      }
      &:hover {
        .asidedirtxt {
          color: #0465ea;
        }
      }
    }
  }
}
</style>